<template>
  <div>

    <!-- 弹出向导层 start-->
    <div id="pop" class="pop" v-show="show_happy">
      <span class="pop_happy_bg" @click="closeshow()"></span>
      <div id="pop_happy_bodyup" class="pop_happy_content">
        <div class="pop_happy_head_close">
          <a class="pop_happy_close" href="javascript:void(0);" @click="hide()"></a>
        </div>
        <div class="blink">
          {{happy_text}}
        </div>
      </div>
    </div>
    <!-- 弹出向导层 end-->


  </div>
</template>

<script>


  import {
    base_encode,
    base_decode
  } from '@/utils/base64.js'

  import mystore from '@/utils/localstore.js';

// import {Happy_Shard,Happy_Rocket} from '@/utils/happy.js';
  // import '@/utils/tx_1.js';

  export default {
    data() {
      return {
        show_happy:false,

        happy_text: '祝你生日快乐!!!',
      };
    },
    mounted: function() {
      const that = this;
      // 滚动事件 scroll
      // 变形事件 resize
      this.$nextTick(function() {
        this.mylogin();
      });
    },
    methods: {

      showpop: function() {
        this.show_happy = true;
        var Hg = $(document).height();
        // 设置背景高度
        $(".pop_happy_bg").height(Hg);
        // 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
        $(".pop_happy_bg").fadeIn("3000");
        $(".pop_happy_content").fadeIn("3000");
        this.happy();
      },
      hide: function() {
        this.show_happy = false;
        $(".pop_happy_bg").fadeOut("3000");
        $(".pop_happy_content").fadeOut("3000");
      },
      closeshow: function() {
        $(".pop_happy_bg").fadeOut("3000");
        $(".pop_happy_content").fadeOut("3000");
        // this.show_filedown=false;
      },
      mylogin: function() {
        let t = (localStorage.getItem('userdata'));

        if (t == null || t === undefined || t == '') {
          this.$message({
            message: '登录信息已经过期,请重新登录!',
            type: 'error'
          });
          return;
        }

        t = JSON.parse(t);
        // console.log(t);
        var is_birthday='';

        is_birthday=t[0].is_birthday;

        if(is_birthday=='1'){
          this.showpop();
          // console.log('展示。。。')
        }else{
          this.closeshow();
          // console.log('隐藏。。。')
        }


      },
      happy:function(){



      }

    }
  };



</script>

<style scoped="scoped">


/* 原始弹出 start */
.pop {
  position: absolute;
  left: 40%;
      top: 40%;
      width: 40%;
  height: auto;
  /* border: 1px solid #ccc; */
  z-index: 9;
  text-align: center;
}

.pop_happy_bg {
  width: 100%;
  background: #000000;
  opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  height: 1340px;
  display: none;
  z-index: 99;
}

.pop_happy_content {
  width: auto;
  height: auto;
  /* background: #faf5f5; */
  /* background-color: azure; */
  position: fixed;

  border-radius: 3px;
  /* display: none; */
  z-index: 999;
  padding: 5px;
  overflow: hidden;
}

.pop_happy_head_close {
  position: absolute !important;
  right: 2px !important;
  top: -9px !important;
  font-size: 30px !important;
  color: #b4b4b4;
  cursor: pointer;
  font-weight: normal;
  display: inline-block;
  text-align: right;
}

/* 以下待删除pop */
.pop_happy_head {
  position: relative;
  /* display: inline-block; */
  text-align: right;
}

.pop_happy_close {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  /* background: url(../../assets/image/schu.png); */

  top: 10px;
  right: 10px;
  line-height: 20px;
  color: #000;
  text-decoration: none;

  margin-left: 0px;
}

.blink{
  color: #ff5500;
  font-size: xxx-large;
}


.pre-body{
  margin: 0;
  background: black;
}

canvas {
  position: absolute;
}

</style>
